<template>
    <div v-if="is_on" id="spinner">
        <svg class="dot-spin" viewBox="0 0 50 50">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
    </div>
</template>
<script>
export default {
    props:['is_on']
}
</script>
